// @ts-nocheck
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { OrderStateContext } from "@insite/client-framework/Store/Data/Orders/OrdersSelectors";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { useContext, useEffect, useState } from "react";
import * as React from "react";
import { infoProps } from "@store/Themes/common/props/info";
import AlertTriangleFill from "@store/Library/Components/Toolkit/Icons/AlertTriangle/AlertTriangleFill";
import Tooltip, { TooltipPresentationProps } from "@store/MobiusOverrides/Tooltip/Tooltip";

export interface OrderDetailsDeliveryTermsStyles {
    titleText?: TypographyPresentationProps;
    termsText?: TypographyPresentationProps;
    wrapper?: InjectableCss;
    changeTooltipAlert?: TooltipPresentationProps;
}

export const deliveryTermsStyles: OrderDetailsDeliveryTermsStyles = {
    titleText: infoProps.label,
    termsText: infoProps.value,
    changeTooltipAlert: {
        iconProps: {
            color: "warning",
            src: AlertTriangleFill,
        },
    },
};
const styles = deliveryTermsStyles;

const OrderDetailsDeliveryTerms = () => {
    const { value: order } = useContext(OrderStateContext);
    const [orderChangePropriety, setOrderChangePropriety] = useState<any>();

    useEffect(() => {
        if (order?.properties.orderChanges) {
            setOrderChangePropriety(JSON.parse(order?.properties.orderChanges));
        }
    }, [order?.properties.orderChanges]);

    if (!order || !order.properties.deliveryTerms) {
        return null;
    }

    return (
        <StyledWrapper {...styles.wrapper}>
            <Typography as="h3" {...styles.titleText}>
                {translate("Delivery Terms")}
            </Typography>
            <Typography {...styles.termsText}>
                {order.properties.deliveryTermsDescription}
                {orderChangePropriety?.deliveryTerms &&
                    orderChangePropriety?.deliveryTerms !== order.properties.deliveryTerms && (
                        <Tooltip
                            text={translate(
                                `Delivery Terms has been updated from {0} to {1}`,
                                orderChangePropriety?.deliveryTerms,
                                order.properties.deliveryTerms,
                            )}
                            {...styles.changeTooltipAlert}
                        />
                    )}
            </Typography>
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: OrderDetailsDeliveryTerms,
    definition: {
        allowedContexts: ["OrderDetailsPage", "VmiOrderDetailsPage"],
        group: "Order Details",
    },
};

export default widgetModule;
